module.exports = __webpack_public_path__ + "static/media/img2.eb609b27.png";